// "/?test=<type>" (N4): another page (Results' Resume, a home card, a link in a message) asks
// the chat to open one test, picking up at the next question when it was started. The landing
// page reads the address and leaves the request here; the chat takes it when it opens.

export const TEST_PARAM = 'test';
export const TEST_TYPES = ['riasec', 'dass42', 'ryff', 'sdq'];
export const OPEN_TEST_EVENT = 'anna:open-test';

let pending = null;

/** The test type in a query string ("?test=dass42"), or null for anything else. */
export const testFromSearch = (search) => {
  const type = String(new URLSearchParams(search || '').get(TEST_PARAM) || '').toLowerCase();
  return TEST_TYPES.includes(type) ? type : null;
};

/** The address that opens this test in the chat. */
export const testLink = (type) => (TEST_TYPES.includes(type) ? `/?${TEST_PARAM}=${type}` : '/');

/** Leave a request for the chat, and tell a chat that's already open. */
export const requestTest = (type) => {
  if (!TEST_TYPES.includes(type)) return;
  pending = type;
  window.dispatchEvent(new CustomEvent(OPEN_TEST_EVENT, { detail: { type } }));
};

/** The waiting request (once), or null. */
export const takeTestRequest = () => {
  const type = pending;
  pending = null;
  return type;
};

/** Tests only. */
export const peekTestRequest = () => pending;
